<div class="main-container">
  <div class="top-bar d-flex justify-content-between align-items-center"></div>

  <div class="nano-banana-section">
    <app-ie [embedded]="true" [showHeader]="false" [showMobileFooter]="false"></app-ie>
  </div>

  <div class="messages-container" #messagesContainer>
    <!-- Placeholder -->
    <div class="chat-placeholder-grid-container" *ngIf="currentMessages.length === 0 && !isLoading">
      <img class="grid-item-logo" src="assets/svg/clarityali.svg" />
      <h1 class="placeholder-title">
        <span class="placeholder-prefix">Create</span>
        <span class="rotating-model">Video</span>
      </h1>
      <h1 class="placeholder-subtitle bigal-sub">
        Generate videos from text (and optionally an image) — then watch them right here.
      </h1>
    </div>

    <!-- Message list -->
    <div
      *ngFor="let msg of currentMessages"
      class="message"
      [ngClass]="{
        'user-message': msg.role === 'user',
        'assistant-message': msg.role === 'assistant'
      }"
    >
      <div *ngIf="msg.content" class="markdown prism-content" [innerHTML]="convertMarkdown(msg.content)"></div>

      <!-- DALL-E Image Section -->
      <div *ngIf="(msg.modelId === 'dale' || msg.modelId === 'dale2legacy') && (msg.image || (msg.images && msg.images.length > 0))" class="dalle-image">
        <img *ngIf="msg.image" [src]="msg.image" class="dalle-img" alt="Generated image" />
        <div *ngIf="msg.images && msg.images.length > 1" class="dalle-variants">
          <img *ngFor="let img of msg.images; let imgIndex = index" [src]="img" class="dalle-img variant" [alt]="'Generated image variant ' + (imgIndex + 1)" />
        </div>
      </div>

      <!-- Generic Image Section (for non-DALL-E models like Stability) -->
      <div *ngIf="(msg.image || (msg.images && msg.images.length)) && msg.modelId !== 'dale' && msg.modelId !== 'dale2legacy'" class="image-result">
        <img *ngIf="msg.image" [src]="msg.image" class="image-result__item" />
        <div class="image-result__variants" *ngIf="msg.images && msg.images.length > 0">
          <img *ngFor="let img of msg.images" [src]="img" class="image-result__item" />
        </div>
      </div>

      <!-- Embedded preview + actions -->
      <div *ngIf="getVideoUrl(msg) as videoUrl" class="video-embed mt-2">
        <!-- Video title -->
        <div class="video-title" *ngIf="getVideoTitle(msg) as videoTitle">
          {{ videoTitle }}
        </div>

        <video
          [attr.poster]="getVideoThumbUrl(msg) || null"
          controls
          playsinline
          preload="metadata"
        >
          <source [src]="videoUrl" type="video/mp4" />
          Your browser does not support the video tag.
        </video>

        <div class="video-actions">
          <!-- In-app overlay player -->
          <button
            type="button"
            class="video-btn"
            (click)="openVideo(videoUrl, getVideoThumbUrl(msg), getVideoTitle(msg))"
          >
            ▶ Watch
          </button>

          <!-- Open in new tab -->
          <a
            class="video-link"
            [href]="videoUrl"
            target="_blank"
            rel="noopener"
          >
            🔗 Open
          </a>

          <!-- Download video -->
          <a
            class="video-link"
            [href]="videoUrl"
            download
            target="_blank"
            rel="noopener"
          >
            ⬇ Download MP4
          </a>
        </div>
      </div>

      <div class="message-timestamp">
        {{ msg.timestamp | date: 'short' }}
        <span *ngIf="msg.modelDisplayName">— {{ msg.modelDisplayName }}</span>
      </div>
    </div>

    <!-- Bird loader while generating -->
    <div *ngIf="isLoading" class="bird-loader-wrap">
      <app-bird-loader label="Thinking"></app-bird-loader>
    </div>
  </div>

  <!-- Input area -->
  <div class="input-container">
    <div class="input-wrapper">
      <input
        #imageInput
        type="file"
        accept="image/*"
        (change)="onImageSelected($event)"
        style="display:none"
      />

      <textarea
        id="videoInputTextarea"
        class="user-input-textarea"
        [(ngModel)]="userInput"
        rows="6"
        placeholder="Describe the video you want…"
        (keydown)="onKeyDown($event)"
        [disabled]="isLoading"
      ></textarea>

      <div class="model-grid-inside">
        <div class="grid-item-inside selector repeat-selector" *ngIf="messageHistory.length > 0">
          <button
            id="previousPromptsBtn"
            class="elephant-btn lovesheet33"
            matTooltip="Click through your prompts (or press ↑)"
            (click)="recallLastMessage()"
          >
            <span class="btn-icon">
              <i class="fas fa-clock-rotate-left"></i>
            </span>
            <span class="btn-text">Repeat Prompt</span>
          </button>
          <span class="repeat-hint">Repeat prompt</span>
        </div>
      </div>

      <!-- image preview -->
      <img *ngIf="selectedImagePreview" [src]="selectedImagePreview" class="upload-preview" />
      <button
        *ngIf="selectedImagePreview"
        class="btn-clear-image"
        type="button"
        (click)="clearImage()"
        [disabled]="isLoading"
        aria-label="Remove image"
        title="Remove image"
      >
        ✕
      </button>

      <!-- attach image -->
      <button
        id="attachVideoImageButton"
        class="btn-attach-fixed"
        [disabled]="isLoading"
        (click)="triggerImageUpload()"
        aria-label="Attach image for video"
      >
        <i class="fas fa-paperclip"></i>
      </button>

      <!-- send -->
      <button
        id="sendVideoButton"
        class="btn-send-fixed inside"
        (click)="sendVideoRequest()"
        [disabled]="isLoading || !userInput.trim()"
        aria-label="Generate video"
      >
        <i class="fas fa-arrow-up"></i>
      </button>
    </div>

    <!-- Controls grid (keep your style) -->
    <div class="model-grid">
      <div class="grid-item selector">
        <button id="videoProviderBtn" class="bigman" type="button" (click)="toggleVideoProviderMenu()">
          <i class="fa-solid fa-film gold"></i>&nbsp;
          <span class="long-text-ai">{{ selectedProviderName }}</span>
        </button>

        <div class="video-provider-menu" *ngIf="showVideoProviderMenu">
          <ul>
            <li
              *ngFor="let provider of videoProviders"
              (click)="selectProvider(provider)"
            >
              {{ provider.label }}
            </li>
          </ul>
        </div>
      </div>

      <div class="grid-item selector">
        <div class="mini-controls">
          <label>AR</label>
          <select class="mini-select" [formControl]="form.controls['aspectRatio']">
            <option value="16:9">16:9</option>
            <option value="9:16">9:16</option>
            <option value="1:1">1:1</option>
          </select>
        </div>
      </div>

      <div class="grid-item selector">
        <div class="mini-controls">
          <label>Sec</label>
          <select class="mini-select" [formControl]="form.controls['seconds']">
            <option [value]="4">4</option>
            <option [value]="6">6</option>
            <option [value]="8">8</option>
            <option [value]="10">10</option>
          </select>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Fullscreen overlay player -->
<div class="video-overlay" *ngIf="isVideoOpen" (click)="closeVideo()">
  <div class="video-modal" (click)="$event.stopPropagation()">
    <div class="video-modal-header">
      <!-- Title of the active video, if provided -->
      <div class="video-modal-title" *ngIf="activeVideoTitle">
        {{ activeVideoTitle }}
      </div>

      <div class="video-modal-controls">
        <button class="video-btn" type="button" (click)="togglePlayPause()">⏯</button>

        <!-- Open in new tab -->
        <a
          class="video-link"
          *ngIf="activeVideoUrl"
          [href]="activeVideoUrl"
          target="_blank"
          rel="noopener"
        >
          🔗 Open
        </a>

        <!-- Download active video -->
        <a
          class="video-link"
          *ngIf="activeDownloadUrl"
          [href]="activeDownloadUrl"
          download
          target="_blank"
          rel="noopener"
        >
          ⬇ Download
        </a>

        <button class="video-btn danger" type="button" (click)="closeVideo()">✕ Close</button>
      </div>
    </div>

    <video
      #videoEl
      [attr.poster]="activeThumbUrl || null"
      controls
      playsinline
      preload="metadata"
    >
      <source *ngIf="activeVideoUrl" [src]="activeVideoUrl" type="video/mp4" />
    </video>
  </div>
</div>
